<template>
  <div id="app" class="feed-back" :class="[dragFeed ? '' : 'feed-back-pointer']">
    <vue-drag-resize :x="130" :y="130" :parentLimitation="true" :isResizable="false" :isActive="true" :w="60" :h="60" v-on:resizing="resize" v-on:dragging="resize">
      <div>
        <div class="feed-back-btn" style="pointer-events: auto">
          <transition name="fade" mode="out-in">
            <div class="btn">
              <div v-if="!msgVisible" @click="clickMsg(true)" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
                <div v-if="!enter" class="icon-msg" />
                <div v-if="enter" class="enter">
                  <div type="primary" class="icon-msg-enter"></div>
                  <div class="icon-msg-enter-text">{{ $t('feedback.feedback1') }}</div>
                </div>
              </div>
              <div v-if="msgVisible" shape="circle" @click="clickMsg(false)">
                <div class="icon-close" />
              </div>
            </div>
          </transition>
        </div>
        <transition name="slide-fade">
          <div style="pointer-events: auto" v-if="msgVisible" class="feed-back-content" @mousedown="mousedown($event)">
            <div class="title">{{ $t('feedback.satisfied') }}</div>
            <a-form :form="form" @submit="handleSubmit">
              <div class="rate">
                <my-rate :score.sync="curScore" showText/>
              </div>
              <a-form-item class="item-form">
                <a-textarea
                  allow-clear
                  :placeholder="$t('feedback.complaints')"
                  class="text-area"
                  :maxlength=500
                  :auto-size="{ minRows: 3, maxRows: 5 }"
                  v-decorator="[
                    'opinion',
                    {
                      rules: [
                        {
                          required: curScore === 0,
                          message: ' ',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
              <a-form-item class="item-form">
                <a-upload :remove="removeImg" v-decorator="['attachment']" :customRequest="beforeUpload" list-type="picture" class="upload-list-inline">
                  <a-button class="btn">
                    <a-icon type="upload" />
                    {{ $t('feedback.upload') }}
                    <!-- 上传图片 -->
                  </a-button>
                </a-upload>
              </a-form-item>
              <a-form-item class="item-form">
                <div class="help">
                  <div><a :href="itUrl" target="_blank">{{ $t('feedback.it') }}</a></div>
                  <a-button class="btn" type="primary" size="small" html-type="submit" :loading="loading"> {{ $t('feedback.send') }} </a-button>
                </div>
              </a-form-item>
            </a-form>
          </div>
        </transition>
        <transition name="slide-fade">
          <div  style="pointer-events: auto" v-if="successVis" class="success">
            <div class="suc-image"></div>
            <div class="thanks">{{ $t('feedback.thanks') }}</div>
            <div>
              <span style="color: #2e6bff">{{ seconds }}</span>
              &nbsp;{{ $t('feedback.close') }}
            </div>
          </div>
        </transition>
      </div>
    </vue-drag-resize>
  </div>
</template>
<script lang="ts">
import axios from 'axios'
// import { t } from './locale';
import MyRate from './myRate.vue'
import VueDragResize from 'vue-drag-resize';
import Tracker from '@ecarx-sparrow/tracker';
import { baseUrl } from './baseUrl';

export default{
  name: 'feedBack',
  components: { MyRate, VueDragResize },
  data() {
    return {
      width: 200,
      height: 200,
      top: 100,
      left: 100,
      enter: false,
      form: this.$form.createForm(this),
      seconds: 3,
      successVis: false,
      msgVisible: false,
      attachment: '',
      desc: ['Very bad！', 'Not good', 'Just so-so', 'Nice！', 'Excellent！'],
      score: 5,
      curScore: 0,
      loading: false,
      dragFeed: false
    }
  },
  props: ['clientId', 'locale', 'env', 'appId', 'login', 'itUrl'],
  created(){
    this.trackFun()
  },
  methods: {
    mousedown (event) {
      event.stopPropagation()
      const tagName = event.target.tagName
      if (tagName === 'INPUT' || tagName === 'TEXTAREA') {
        event.target.focus()
      }
    },
    trackFun() {
      const tracker = new Tracker({
        env:  this.env,
        appId: this.appId,
      })
      this.tracker = tracker
    },
    trackCli(mg){
      this.tracker.sendError('tc', mg)
    },
    resize(newRect) {
      this.width = newRect.width;
      this.height = newRect.height;
      this.top = newRect.top;
      this.left = newRect.left;
    },
    mouseEnter(){
      this.enter = true
    },
    mouseLeave(){
      this.enter = false
    },
    clickMsg(code) {
      code ? this.trackCli('clickFeedback_C') : this.trackCli('closeSubmit1_C')
      this.msgVisible = !this.msgVisible
      this.successVis = false
      this.form.resetFields();
      this.attachment = ''
    },
    handleSubmit(e) {
      e.preventDefault();
      const {baseDevUrl, baseRealUrl, feedbackCreate} = baseUrl
      this.form.validateFields((err, values) => {
          const params = {
            ...values,
            score: this.curScore,
            clientId: this.clientId,
            attachment: this.attachment,
            remarks: window.location.href,
          }

          if(params.opinion !== undefined || params.score !== 0){
            this.loading = true
            const gatewayUrl = this.env ==='prd' ? baseRealUrl: baseDevUrl
            axios.post(`${gatewayUrl}${feedbackCreate}`, { ...params },
              {headers: {'Content-Type': 'application/json'},withCredentials: true}
            ).then((res) => {
              console.log('create-res: ', res);
              this.form.resetFields();
              if(res && res.data.success){
                this.msgVisible = false //表单页隐藏
                this.successVis = true //成功页
                this.enter = false
                this.loading = false
                let times = setInterval(() => {
                  if(this.seconds > 0){
                    this.seconds--
                  }
                  if (this.seconds <= 0) {
                    this.successVis = false
                    this.seconds = 3
                    clearInterval(times);
                    this.trackCli('closeSubmit2_C')
                  }
                }, 1000);
              } else{
                this.$message.error(err.message || '出错了，请稍后重试')
                this.loading = false
              }
            }).catch((err) => {
              console.log('create-err: ', err.message);
              this.$message.error(err.message || '出错了，请稍后重试')
              this.loading = false
            })
          }
      });
      this.trackCli('clickSubmit_C')
    },
    beforeUpload(options) {
        const { onSuccess, file, onProgress } = options
        const {baseDevUrl, baseRealUrl, fileUrl, staticUrl} = baseUrl
        const gatewayUrl = this.env ==='prd' ? baseRealUrl: baseDevUrl
        const formData = new FormData();
        formData.append('content', file);
        axios.post(
          `${gatewayUrl}${fileUrl}?fileName=${file.name}&clientId=${this.clientId}&isPublic=true`,
          formData, 
          {
            headers: {'Content-Type': 'multipart/form-data'},
            withCredentials: true,
          }
        ).then((res) => {
          console.log('upload-res1: ', res);
          let fileId = res.data.content.fileId
          if(fileId){
            axios.post(`${gatewayUrl}${staticUrl}`, {fileIds: [fileId]},{
              headers: {'Content-Type': 'application/json'},
              withCredentials: true,
            }).then((res) => {
              if(res){
                console.log('upload-res2: ', res);
                let staticUrl = res.data.content[0].staticUrl
                this.attachment += staticUrl + ','
                onProgress({ percent: 100 })
                onSuccess(res, file)
              }
            }).catch((err) => {
              console.log('upload-err2: ', err);
              this.$message.error(err.message || '出错了，请稍后重试')
            })
          } else {
            this.$message.error('fileId不存在，请稍后重试')
          }
        }).catch((err) => {
          console.log('upload-err1: ', err);
          this.$message.error(err.message || '出错了，请稍后重试')
        })
    },
    removeImg(data){
      let delImgurl = data.response.data.content[0].staticUrl
      if(delImgurl){
        this.attachment = this.attachment.replace(delImgurl+`,`, '')
      } else {
        this.attachment = ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .feed-back {
    width: 200px;
    height: 200px !important;
    position: fixed;
    bottom: 0px;
    right: 0px;
    z-index: 999;
    /deep/ .vdr.active:before{
      outline: 1px dashed #FFF;
      opacity: 0;
    }
    .feed-back-btn {
      position: relative;
      .btn{
        .icon-msg {
          width: 45px;
          height: 45px;
          background-image: url('https://cdn.ecarxgroup.com/f-static/feedback-msg3.png');
          background-size: 100% 100%;
          background-position: center;
          background-repeat: no-repeat;
          cursor: pointer;
        }
        .enter{
          display: flex;
          align-items: center;
          justify-content: center;
          width: 114px;
          height: 45px;
          background-color: #2E6BFF;
          border-radius: 24px;
          position: absolute;
          right: 8px;
          cursor: pointer;
          .icon-msg-enter{
            width: 18px;
            height: 20px;
            background-image: url('https://cdn.ecarxgroup.com/f-static/feedback-enter.png');
            background-size: 100% 100%;
            background-position: center;
            background-repeat: no-repeat;
            margin-right: 7px;
            cursor: pointer;
          }
          .icon-msg-enter-text{
            color: #fff;
          }
        }
        .icon-close {
          width: 45px;
          height: 45px;
          background-image: url('https://cdn.ecarxgroup.com/f-static/feedback-close3.png');
          background-size: 100% 100%;
          background-position: center;
          background-repeat: no-repeat;
          border: 1px solid #F0F0F0;
          border-radius: 50%;
          cursor: pointer;
        }
      }
    }

    .slide-fade-enter-active {
      transition: all .3s ease;
    }
    .slide-fade-leave-active {
      transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */ {
      transform: translateX(10px);
      opacity: 0;
    }
    .feed-back-content {
      width: 400px;
      min-height: 274px;
      padding: 16px;
      background-color: #fff;
      box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      position: absolute;
      right: 13px;
      bottom: 66px;
      .title {
        font-size: 16px;
      }
      .rate{
        margin: 17px 0 21px 0;
        cursor: pointer;
      }
      .item-form {
        margin: 0;
        /deep/ .ant-input{
          resize: none;
        }
        // /deep/ .anticon-close {
          // display: none;
          // width: 12px;
          // height: 13px;
          // background-image: url('https://cdn.ecarxgroup.com/f-static/feedback-del.png');
          // background-size: 100% 100%;
          // background-position: center;
          // background-repeat: no-repeat;
        // }
      }
      .text-area {
        // margin-bottom: 10px;
        // height: 70px;
        /deep/ .ant-input{
          resize: none;
        }
      }

      .upload-list-inline {
        color: #8c8c8c;
        .btn {
          color: #8c8c8c;
        }
        /deep/ .ant-upload-list-item-card-actions{
          width: 12px;
          height: 13px;
          background-image: url('https://cdn.ecarxgroup.com/f-static/feedback-del.png');
          background-size: 100% 100%;
          background-position: center;
          background-repeat: no-repeat;
          margin-right: 8px;
        }
        /deep/ .anticon-delete{
          width: 12px;
          height: 13px;
          background-image: url('https://cdn.ecarxgroup.com/f-static/feedback-del.png');
          background-size: 100% 100%;
          background-position: center;
          background-repeat: no-repeat;
          margin-right: 8px;
        }
        /deep/ .ant-upload-list-picture{
          display: inline;
        }
      }
      .help {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .btn {
          height: 30px;
          border-radius: 5px;
          box-shadow: 0px 2px 10px rgba(46, 107, 255, 0.4);
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
    .success {
      width: 400px;
      min-height: 274px;
      padding: 16px;
      background-color: #fff;
      box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      position: absolute;
      right: 13px;
      bottom: 66px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      box-sizing: content-box;
      .suc-image{
        width: 200px;
        height: 200px;
        background-image: url('https://cdn.ecarxgroup.com/f-static/feedback-hand.png');
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
      }
      .thanks {
        margin: 10px 0 12px 0;
        font-size: 16px;
      }
    }
    .close {
      .fadeOut;
    }
    .fadeOut(@time:3s) {
      @keyframes fadeOutBottom {
        0% {
          opacity: 1;
          transform: translateY(0);
        }
        // 50% {
        //   opacity: 1;
        //   transform: translateY(0);
        // }
        100% {
          opacity: 0;
          transform: translateY(100%);
        }
      }
      animation-name: fadeOutBottom;
      animation-duration: @time;
      animation-timing-function: ease-out;
      animation-fill-mode: forwards;
    }
    .starScore {
      .icon-star {
        cursor: pointer;
        color: #E4E4E4;
        &.half {
          background: linear-gradient(to right, #FFA940 50%, #E4E4E4 0);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        &.active {
          color: #FFA940;
        }
      }

      .starScore-key {
        color: #FFA940;
        padding-left: 5px;
      }
    }

  }
  .feed-back-pointer {
    pointer-events: none;
  }
</style>
